<template> 
  <div class="wrapper">
    <div class="animated fadeIn dashboard-container">
      <!-- FirstMile -->
      <div v-if="pickuplocationmasterid == 365 || pickuplocationmasterid == 11">
        <b-row>
          <b-col cols="12">
            <b-breadcrumb :items="breadcrumbs" />
            <b-card class="m-0 p-0" v-if="pickuplocationmasterid == 365 && userCountry == 'KSA'">
              <div>
                <b>B2B Dashboard</b><br><br>
                
                <span>B2B Forward</span>
                <b-row v-show="Object.keys(b2bDashboardCount).length > 0">
                  <b-col cols="2" v-for="item,index of Object.entries(b2bDashboardCount)" :key="item[0]">
                    <a :href="item[0]" style="text-decoration: none;" @click.prevent="goToB2B">
                      <b-card :class="b2bDashboardColorArr[index % b2bDashboardColorArr.length]">
                        <b-card-body class="d-flex flex-column align-items-center text-white m-0 p-0">
                          <span class="display-3">{{ item[1] }}</span>
                          <span>{{ item[0] }}</span>
                        </b-card-body>
                      </b-card>
                    </a>
                  </b-col>
                </b-row>

                <span>B2B Reverse</span>
                <b-row v-show="Object.keys(b2bReverseDashboardCount).length > 0">
                  <b-col cols="2" v-for="item,index of Object.entries(b2bReverseDashboardCount)" :key="item[0]">
                    <a :href="item[0]" style="text-decoration: none;" @click.prevent="goToB2B">
                      <b-card :class="b2bRevDashboardColorArr[index % b2bRevDashboardColorArr.length]">
                        <b-card-body class="d-flex flex-column align-items-center text-white m-0 p-0">
                          <span class="display-3">{{ item[1] }}</span>
                          <span>{{ item[0] }}</span>
                        </b-card-body>
                      </b-card>
                    </a>
                  </b-col>
                </b-row>
                <b-row v-show="showB2BDashboardLoader || failMsgForB2BDashboard">
                  <b-col>
                      <b-card>
                        <b-card-body class="d-flex flex-column align-items-center text-dark m-0 p-0">
                        <span class="spinner-border" v-show="showB2BDashboardLoader"></span>
                        <span v-show="failMsgForB2BDashboard">{{failMsgForB2BDashboard}}</span>
                        </b-card-body>
                      </b-card>
                  </b-col>
                </b-row>
              </div>
            </b-card>
            <!-- Code added -->
            <b-card
              header-tag="header"
              footer-tag="footer"
              style=" margin-bottom: 0px;height:120vh"
            >
              <label v-if="userCountry != 'KSA'">Overall Firstmile</label>
              <b-row class="boxto" v-if="userCountry != 'KSA'">
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup Assigned"
                        >
                          {{ this.CountFirstmile3plpickupassigned }}
                        </h4>
                        <p
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup Assigned"
                        >
                          Not Attempted:Rider Assigned
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup Not Assigned"
                        >
                          {{ this.CountFirstmile3plpickupnotassigned }}
                        </h4>
                        <p
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="Overall Not Attempted:Rider Not Assigned"
                        >
                          Not Attempted:Rider Not Assigned
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup(INTransit)"
                        >
                          {{ CountFirstmile3plpickupintransist }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup(INTransit)"
                        >
                          Pickup(INTransit)
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-green">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="Pick Cancelled"
                        >
                          {{ CountFirstmile3plpickuppickcancel }}
                        </h4>
                        <p
                          style="padding-bottom:20px;"
                          class="text-center countcolor "
                          v-b-tooltip.hover
                          title="Pick Cancelled"
                        >
                          Pick Cancelled
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-pink">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="3PL Hub Handover Done"
                        >
                          {{ CountFirstmile3plpickuphandoverdone }}
                        </h4>
                        <p
                          style="padding-bottom:20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="Handover To 3PL Hub"
                        >
                          Handover To 3PL Hub
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" v-if="userCountry == 'KSA'">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="3PL Pickup Not Received Count"
                        >
                         0 <!-- {{ CountFirstmile3plpickupNotassignedreceived }} -->
                        </h4>
                        <p
                          style="padding-bottom:20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="Pickup By 3PL"
                        >
                          Pickup By 3PL &nbsp;&nbsp;&nbsp;&nbsp;
                        </p>
                      </b-card-body>
                    </li>
                  </b-card>
                </b-col>
              </b-row>

              <!-- Code added -->
              <label v-if="userCountry != 'KSA'">3PL Hub Drop[vendor to 3rd party Hub]</label>
              <b-row class="boxto" v-if="userCountry != 'KSA'">
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ Firstmile3plpickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ Firstmile3plpickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Pickup_INTransit' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            {{ Firstmile3plpickupintransist }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            Pickup(INTransit)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Pick_Cancelled' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            {{ Firstmile3plpickuppickcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            Pick Cancelled
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Hub_Handover_Done' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Hub Handover Done"
                          >
                            {{ Firstmile3plpickuphandoverdone }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Hub Handover Done"
                          >
                            Handover To 3PL Hub
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="userCountry == 'KSA'"
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'PL_Pickup_Not_Assigned_Received' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup By 3PL Not Received Count"
                          >
                            <!-- {{  }} -->0
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Pickup Not Assigned Received"
                          >
                            Pickup By 3PL
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
              </b-row>

              <label style="padding-top: 10px!important"
                >P2P Hub Drop[Vendor to DWC]</label
              >
              <b-row class="boxto">
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ Firstmilep2ppickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ Firstmilep2ppickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Pickup_INTransit' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            {{ Firstmilep2ppickupintransist }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            Pickup(INTransit)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Pick_Cancelled' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            {{ Firstmilep2ppickuppickcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            Pick Cancelled
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Handoverdone_to_P2P_Hub' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Handoverdone to P2P Hub"
                          >
                            {{ Firstmilep2ppickuphandoverdone }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Handoverdone to P2P Hub"
                          >
                            Handoverdone to P2P Hub
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="userCountry != 'KSA'"
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Pickup_Not_Assigned_Received' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick By 3PL Not Received"
                          >
                            {{ Firstmilep2ppickupnotreceived }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Vendor Pickup Not Assigned"
                          >
                            Pick By 3PL
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
              </b-row>

              <label v-if="userCountry != 'KSA'">Trendyol:Firstmile</label>
              <b-row v-if="userCountry != 'KSA'" class="boxto" >
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ FirstmileTrendyolpickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ FirstmileTrendyolpickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Pickup_INTransit' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            {{ FirstmileTrendyolpickupintransit }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            Pickup(INTransit)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Pick_Cancelled' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            {{ FirstmileTrendyolpickuppickcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            Pick Cancelled
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Hub_Handover_Done' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Handoverdone to P2P Hub"
                          >
                            {{ FirstmileTrendyolpickuphandoverdone }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Handoverdone to P2P Hub"
                          >
                            Handoverdone to P2P Hub
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <!-- <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="userCountry != 'KSA'"
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Firstmile_Trendyol_Pickup_Not_Assigned_Received' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick By 3PL Not Received"
                          >
                            {{ FirstmileTrendyolpickupNotassignedreceived }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Vendor Pickup Not Assigned"
                          >
                            Pick By 3PL
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col> -->
              </b-row>

              <!-- Trendyol:Firstmile-->

              <div v-if="userCountry=='KSA'">
                  <!-- Code added by Sachin
            Date:12/02/2020 -->

            <label style="padding-top: 10px!important;"
            >Overall Lastmile</label
          >
          <!-- For ME -->
          <b-row class="boxto" v-if="userCountry == 'ME'">
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Assigned"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Assigned"
                    >
                      Not Attempted:Rider Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-purpal">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Not Assigned"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupnotassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Not Assigned"
                    >
                      Not Attempted:Rider Not Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-def">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup (OFD)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupofd }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup (OFD)"
                    >
                      Pickup (OFD)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-green">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupcancel }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      Pick Cancelled(NPR)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Delivered at Customer"
                    >
                      {{ CountLasttmileWH_Lasttmiledeliveratcustomer }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Delivered at Customer"
                    >
                      Delivered at Customer
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      {{ CountLasttmileWH_Lasttmilepickndr }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      NDR (HandoverPending)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Return To Origin"
                    >
                      {{ CountLasttmileWH_Lasttmilerto }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Return To Origin"
                    >
                      RTO
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2" v-if="userCountry == 'KSA'">
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall WH_Vendor Pickup Count"
                    >
                      {{ CountLasttmile_Vendor_WH_Pickup_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall WH_Vendor Pickup Count"
                    >
                      Pickup
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col
              sm="6"
              lg="2"
              v-if="
                (userCountry == 'ME' && pickuplocationmasterid == 36058) ||
                  (userCountry == 'ME' &&
                    pickuplocationmasterid == 78731) ||
                  userCountry == 'KSA'
              "
            >
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      {{ CountLasttmile_Vendor_WH_HubInscan_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      Hub InScan
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <!-- Overall Lastmile -->
          <!-- For KSA -->
          <b-row class="boxto" v-if="userCountry == 'KSA'">
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-purpal">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupnotassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Shipment Created"
                    >
                      Shipment Created
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Received in HUB Count"
                    >
                      {{ CountLasttmile_Vendor_WH_Pickup_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Received in HUB"
                    >
                      Received in HUB
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Rider Assigned"
                    >
                      Rider Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-def">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="OFD Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupofd }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="OFD"
                    >
                      OFD
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Today's Delivered at Customer Count"
                    >
                      {{ CountLasttmileWH_Lasttmiledeliveratcustomer }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Today's Delivered at Customer"
                    >
                      Today's Delivered at Customer
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickndr }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      NDR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR Received Count"
                    >
                      {{ CountLastmileWH_NDRReceived }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="NDR Received"
                    >
                       Received NDR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-green">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupcancel }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      NPR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      {{ CountLasttmile_Vendor_WH_HubInscan_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      Hub InScan
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall RTOSCAN COUNT"
                    >
                      {{ CountLasttmile_Vendor_WH_RTOSCAN_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall  RTOSCAN Count"
                    >
                      Final RTO
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2" v-if="pickuplocationmasterid == 365 ">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Missing Shipment Count"
                    >
                    {{LasttmileWH_Lasttmilemissingshipmentcount}}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Missing Shipment"
                    >
                    Missing Shipment
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2" class="pb-5">
              <b-card no-body class="bg-purpal">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall RINTransit Count"
                    >
                      {{ CountLastmile_Vendor_WH_RINTransit_Count }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall RINTransit"
                    >
                    R in transit
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="boxto" style="padding-bottom: 50px!important;">
            <b-col sm="6" lg="2" class="pb-5">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Excess Shipment Count"
                    >
                      {{ LasttmileWH_Lasttmileexcessshipmentcount }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Excess Shipment"
                    >
                    Excess Shipment
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <br>
          <!-- For KSA End -->
          <!-- Overall Lastmile Code End -->
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- FirstMile End -->

      <div style="display: none;" id="element">
        <b-row>
          <b-col cols="12">
            <b-card
              header-tag="header"
              footer-tag="footer"
              style=" margin-bottom: 0px;"
            >
            <div v-if="userCountry == 'ME'">
                <!-- Code added by Sachin
            Date:12/02/2020 -->

            <label style="padding-top: 10px!important"
            >Overall Lastmile</label
          >
          <!-- For ME -->
          <b-row class="boxto" v-if="userCountry == 'ME'">
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Assigned"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Assigned"
                    >
                      Not Attempted:Rider Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-purpal">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Not Assigned"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupnotassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup Not Assigned"
                    >
                      Not Attempted:Rider Not Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-def">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup (OFD)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupofd }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Pickup (OFD)"
                    >
                      Pickup (OFD)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-green">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupcancel }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      Pick Cancelled(NPR)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Delivered at Customer"
                    >
                      {{ CountLasttmileWH_Lasttmiledeliveratcustomer }}
                    </h4>
                    <p
                      style="padding-bottom: 20px;"
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Delivered at Customer"
                    >
                      Delivered at Customer
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      {{ CountLasttmileWH_Lasttmilepickndr }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      NDR (HandoverPending)
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Return To Origin"
                    >
                      {{ CountLasttmileWH_Lasttmilerto }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Return To Origin"
                    >
                      RTO
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2" v-if="userCountry == 'KSA'">
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall WH_Vendor Pickup Count"
                    >
                      {{ CountLasttmile_Vendor_WH_Pickup_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall WH_Vendor Pickup Count"
                    >
                      Pickup
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col
              sm="6"
              lg="2"
              v-if="
                (userCountry == 'ME' && pickuplocationmasterid == 36058) ||
                  (userCountry == 'ME' &&
                    pickuplocationmasterid == 78731) ||
                  userCountry == 'KSA'
              "
            >
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      {{ CountLasttmile_Vendor_WH_HubInscan_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      Hub InScan
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <!-- Overall Lastmile -->
          <!-- For KSA -->
          <b-row class="boxto" v-if="userCountry == 'KSA'">
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-purpal">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupnotassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Shipment Created"
                    >
                      Shipment Created
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Received in HUB Count"
                    >
                      {{ CountLasttmile_Vendor_WH_Pickup_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Received in HUB"
                    >
                      Received in HUB
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupassigned }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Rider Assigned"
                    >
                      Rider Assigned
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-def">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="OFD Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupofd }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="OFD"
                    >
                      OFD
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Today's Delivered at Customer Count"
                    >
                      {{ CountLasttmileWH_Lasttmiledeliveratcustomer }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Today's Delivered at Customer"
                    >
                      Today's Delivered at Customer
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR Count"
                    >
                      {{ CountLasttmileWH_Lasttmilepickndr }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR"
                    >
                      NDR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="NDR Received Count"
                    >
                      {{ CountLastmileWH_NDRReceived }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="NDR Received"
                    >
                       Received NDR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>

            <b-col sm="6" lg="2">
              <b-card no-body class="bg-green">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      {{ CountLasttmileWH_Lasttmilepickupcancel }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Pick Cancelled(NPR)"
                    >
                      NPR
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              
              <b-card no-body class="bg-yellow">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      {{ CountLasttmile_Vendor_WH_HubInscan_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall Hub InScan Count"
                    >
                      Hub InScan
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-aqua">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Overall RTOSCAN COUNT"
                    >
                      {{ CountLasttmile_Vendor_WH_RTOSCAN_Count }}
                    </h4>
                    <p
                      class="text-center countcolor "
                      v-b-tooltip.hover
                      title="Overall  RTOSCAN Count"
                    >
                      Final RTO
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
            <b-col sm="6" lg="2" v-if="pickuplocationmasterid == 365 ">
              <b-card no-body class="bg-red">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Missing Shipment Count"
                    >
                    {{LasttmileWH_Lasttmilemissingshipmentcount}}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Missing Shipment"
                    >
                    Missing Shipment
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="boxto">
            <b-col sm="6" lg="2">
              <b-card no-body class="bg-pink">
                <li>
                  <b-card-body class="pb-0">
                    <h4
                      class="mb-0 display-3 text-center countcolor"
                      v-b-tooltip.hover
                      title="Excess Shipment Count"
                    >
                      {{ LasttmileWH_Lasttmileexcessshipmentcount }}
                    </h4>
                    <p
                      class="text-center countcolor"
                      v-b-tooltip.hover
                      title="Excess Shipment"
                    >
                    Excess Shipment
                    </p>
                  </b-card-body>
                </li>
              </b-card>
            </b-col>
          </b-row>
          <!-- For KSA End -->
          <!-- Overall Lastmile Code End -->
            </div>
              <strong class="heading">Lastmile</strong>
              <!-- Last Mile -->
              <label style="padding-top: 10px!important">WH:Lastmile</label>
              <!-- For ME -->
              <b-row class="boxto" v-if="userCountry == 'ME'">
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ LasttmileWH_Lasttmilepickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ LasttmileWH_Lasttmilepickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_OFD' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup (OFD)"
                          >
                            {{ LasttmileWH_Lasttmilepickupofd }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup (OFD)"
                          >
                            Pickup (OFD)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pick_Cancelled_NPR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            {{ LasttmileWH_Lasttmilepickupcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            Pick Cancelled(NPR)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Delivered_at_Customer' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered at Customer"
                          >
                            {{ LasttmileWH_Lasttmiledeliveratcustomer }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered at Customer"
                          >
                            Delivered at Customer
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_NDR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            {{ LasttmileWH_Lasttmilepickndr }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            NDR (HandoverPending)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_RTO' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            {{ LasttmileWH_Lasttmilerto }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="userCountry == 'KSA'"
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Not_Assigned_Received' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="WH Pickup Not Assigned Received"
                          >
                            {{ LasttmileWHpickup }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="WH Pickup Not Assigned Received"
                          >
                            WH Pickup
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="
                    (userCountry == 'ME' && pickuplocationmasterid == 36058) ||
                      (userCountry == 'ME' &&
                        pickuplocationmasterid == 78731) ||
                      userCountry == 'KSA'
                  "
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_HubInscan_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="WH HubInscan Count"
                          >
                            {{ LasttmileWH_HubInscan_Count }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="WH HubInscan Count"
                          >
                            Hub Inscan
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                
              </b-row>
              <!-- For ME END -->
              <!-- For KSA -->
              <b-row class="boxto" v-if="userCountry == 'KSA'">
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Shipment Created Count"
                          >
                            {{ LasttmileWH_Lasttmilepickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Shipment Created"
                          >
                            Shipment Created
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Not_Assigned_Received' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Received in HUB Count"
                          >
                            {{ LasttmileWHpickup }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Received in HUB"
                          >
                            Received in HUB
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Rider Assigned Count"
                          >
                            {{ LasttmileWH_Lasttmilepickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Rider Assigned"
                          >
                            Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_OFD' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="OFD Count"
                          >
                            {{ LasttmileWH_Lasttmilepickupofd }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="OFD"
                          >
                            OFD
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Delivered_at_Customer' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Today's Delivered at Customer"
                          >
                            {{ LasttmileWH_Lasttmiledeliveratcustomer }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Today's Delivered at Customer"
                          >
                            Today's Delivered at Customer
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_NDR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR Count"
                          >
                            {{ LasttmileWH_Lasttmilepickndr }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR (Handoverpending)"
                          >
                            NDR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_RTOINSCAN' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Return To Origin Count"
                          >
                            {{ LastmileWH_NDRReceived }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Received NDR"
                          >
                            Received NDR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pick_Cancelled_NPR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NPR Count"
                          >
                            {{ LasttmileWH_Lasttmilepickupcancel }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            NPR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_HubInscan_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="WH HubInscan Count"
                          >
                            {{ LasttmileWH_HubInscan_Count }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="WH HubInscan Count"
                          >
                            Hub Inscan
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_RTO' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="WH RTOscan Count"
                          >
                            {{ LasttmileWH_RTOscan }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="WH RTOscan Count"
                          >
                            Final RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Pickup_OFP' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="OFP Count"
                          >
                            {{ Lastsmile_WH_Pickup_OFP }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="OFP Count"
                          >
                            OFP
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                
                <b-col sm="6" lg="2" class="pointer" v-if="LasttmileWH_Lasttmileclientpickcancle">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'ClientPickCancel_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Client Pick Cancel Count"
                          >
                            {{ LasttmileWH_Lasttmileclientpickcancle }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Client Pick Cancel"
                          >
                          Client Pick Cancel
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer" v-if="pickuplocationmasterid == 365 ">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Missing_Shipment' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Missing Shipment Count"
                          >
                            {{ LasttmileWH_Lasttmilemissingshipmentcount }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Missing Shipment"
                          >
                          Missing Shipment
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_RINTransit' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="WH RINTransit Count"
                          >
                            {{ LastmileWH_RINTransit }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="WH RINTransit"
                          >
                            R in transit
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

              <!-- </b-row>

              <b-row class="boxto"> -->
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'WH_Excess_Shipment' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Excess Shipment Count"
                          >
                            {{ LasttmileWH_Lasttmileexcessshipmentcount }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Excess Shipment"
                          >
                          Excess Shipment
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
              </b-row>
              <!-- For KSA End -->
              <!-- LastMile End -->
              <!-- Vendor LastMile -->
              <label style="padding-top: 10px!important">Vendor:Lastmile</label>
              <b-row
                class="boxto"
                v-if="userCountry == 'ME'"
              >
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ LasttmileVendor_Lasttmilepickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ LasttmileVendor_Lasttmilepickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_OFD' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(OFD)"
                          >
                            {{ LasttmileVendor_Lasttmilepickupofd }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pickup(OFD)"
                          >
                            Pickup(OFD)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pick_Cancelled_NPR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            {{ LasttmileVendor_Lasttmilepickupnotcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            Pick Cancelled(NPR)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: {
                            id: 'Vendor_Lastmile_Delivered_at_Customer',
                          },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered to Customer"
                          >
                            {{ LasttmileVendor_Lasttmiledeliveratcustomer }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered to Customer"
                          >
                            Delivered to Customer
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_NDR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            {{ LasttmileVendor_Lasttmilepickcancelnpr }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            NDR (HandoverPending)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_RTO' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            {{ LasttmileVendor_Lasttmilerto }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="userCountry == 'KSA'"
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: {
                            id: 'Vendor_Lastmile_Pickup_Not_Assigned_Received',
                          },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Vendor Pickup Not Assigned Received"
                          >
                            {{ LasttmileVendor_Pickupnotassignedreceived }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Vendor Pickup Not Assigned Received"
                          >
                            Vendor Pickup
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                
                <b-col
                  sm="6"
                  lg="2"
                  class="pointer"
                  v-if="
                    (userCountry == 'ME' && pickuplocationmasterid == 36058) ||
                      (userCountry == 'ME' &&
                        pickuplocationmasterid == 78731) ||
                      userCountry == 'KSA'
                  "
                >
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_HubInscan_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            {{ LasttmileVendor_HubInscan_Count }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            Hub Inscan
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col
                sm="6"
                lg="2"
                class="pointer"
                v-if="userCountry == 'KSA'"
              >
                <b-card no-body class="bg-yellow">
                  <li>
                    <router-link
                      tag="li"
                      :to="{
                        name: 'shipmentreport',
                        params: {
                          id: 'Vendor RTO Scan',
                        },
                      }"
                    >
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-3 text-center countcolor"
                          v-b-tooltip.hover
                          title="Vendor RTO Scan"
                        >
                          {{ Lastmile_RTOINSCAN }}
                        </h4>
                        <p
                          class="text-center countcolor "
                          v-b-tooltip.hover
                          title="Vendor RTO Scan"
                        >
                          Vendor RTO Scan
                        </p>
                      </b-card-body>
                    </router-link>
                  </li>
                </b-card>
              </b-col>
              </b-row>

              <b-row
                class="boxto"
                style="border-bottom: 2px dotted grey "
                v-if="userCountry == 'KSA'"
              >
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Shipment Created Count"
                          >
                            {{ LasttmileVendor_Lasttmilepickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Shipment Created"
                          >
                            Shipment Created
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_HubInscan_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            {{ LasttmileVendor_HubInscan_Count }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            Hub Inscan
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <!-- <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: {
                            id: 'Vendor_Lastmile_Pickup_Not_Assigned_Received',
                          },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Received in HUB Count"
                          >
                            {{ LasttmileVendor_Pickupnotassignedreceived }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Received in HUB"
                          >
                            Received in HUB
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col> -->
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Rider Assigned Count"
                          >
                            {{ LasttmileVendor_Lasttmilepickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Rider Assigned"
                          >
                            Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pickup_OFD' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="OFD Count"
                          >
                            {{ LasttmileVendor_Lasttmilepickupofd }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="OFD"
                          >
                            OFD
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: {
                            id: 'Vendor_Lastmile_Delivered_at_Customer',
                          },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered to Customer"
                          >
                            {{ LasttmileVendor_Lasttmiledeliveratcustomer }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Today's Delivered to Customer"
                          >
                            Today's Delivered at Customer
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_NDR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR Count"
                          >
                            {{ LasttmileVendor_Lasttmilepickcancelnpr }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR (Handoverpending)"
                          >
                            NDR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_RTOINSCAN' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Received NDR Count"
                          >
                            {{ LasttmileVendor_NDRReceived }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Received NDR"
                          >
                            Received NDR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_Pick_Cancelled_NPR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NPR Count"
                          >
                            {{ LasttmileVendor_Lasttmilepickupnotcancel }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            NPR
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <!-- <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-yellow">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_HubInscan_Count' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            {{ LasttmileVendor_HubInscan_Count }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Vendor HubInScan Count"
                          >
                            Hub Inscan
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col> -->

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_RTO' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Final Count"
                          >
                            {{ LastmileVendor_Vendor_Lastmile_RTO }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Final Count"
                          >
                            Final RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Vendor_Lastmile_RINTransit' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Vendor RINTransit Count"
                          >
                            {{ LastmileVendor_Vendor_Lastmile_RINTransit }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Vendor RINTransit"
                          >
                            R in transit
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
              </b-row>

              <!-- Trendyol:Lastmile For ME -->
              <label style="padding-top: 10px!important" v-if="userCountry == 'ME'">Trendyol:Lastmile</label>
              <b-row class="boxto" style="border-bottom: 2px dotted grey " v-if="userCountry == 'ME'">
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_Pickup_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ LasttmileTrendyol_Lasttmilepickupassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-purpal">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_Pickup_Not_Assigned' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ LasttmileTrendyol_Lasttmilepickupnotassigned }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-def">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_Pickup_OFD' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup (OFD)"
                          >
                            {{ LasttmileTrendyol_Lasttmilepickupofd }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup (OFD)"
                          >
                            Pickup (OFD)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_Pick_Cancelled_NPR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            {{ LasttmileTrendyol_Lasttmilepickupcancel }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled(NPR)"
                          >
                            Pick Cancelled(NPR)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-pink">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_Delivered_at_Customer' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered at Customer"
                          >
                            {{ LasttmileTrendyol_Lasttmiledeliveratcustomer }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Delivered at Customer"
                          >
                            Delivered at Customer
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-red">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_NDR' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            {{ LasttmileTrendyol_Lasttmilepickndr }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="NDR"
                          >
                            NDR (HandoverPending)
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-aqua">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'shipmentreport',
                          params: { id: 'Trendyol_RTO' },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            {{ LasttmileTrendyol_Lasttmilerto }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Return To Origin"
                          >
                            RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                
              </b-row>

              <!-- Vendor Last Mile End -->
              <!-- v-if="
                  pickuplocationmasterid == 365 ||
                    pickuplocationmasterid == 36058 ||
                    pickuplocationmasterid == 78731 ||
                    pickuplocationmasterid == 11 ||
                    pickuplocationmasterid == 567 ||
                    pickuplocationmasterid == 568 ||
                    pickuplocationmasterid == 566 || pickuplocationmasterid == 435 || pickuplocationmasterid == 590 || pickuplocationmasterid == 592 || pickuplocationmasterid == 6331      
                " -->

              <div v-if="pickuplocationmasterid == 365 ">
                  <label style="padding-top: 10px!important">R-In Scan</label>
                  <b-row
                  class="boxto"
                  style="border-bottom: 2px dotted grey "
                >
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'RInScan' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="R-In Scan "
                            >
                              {{ RInScan }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="RInScan"
                            >
                              R-In Scan
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

              </div>

              <div
               v-if="pickuplocationmasterid == 365 ||pickuplocationmasterid==36058 || pickuplocationmasterid==78731||pickuplocationmasterid == 11 || pickuplocationmasterid == 435 || pickuplocationmasterid == 590 || pickuplocationmasterid == 592 || pickuplocationmasterid == 6331"
                
               >
                <label style="padding-top: 10px!important">Reverse & RTD</label>

                <!-- Reverse & RTD-->
                <!-- For ME -->
                <b-row
                  class="boxto"
                  style="border-bottom: 2px dotted grey "
                  v-if="userCountry == 'ME'"
                >
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse pickup Assigned"
                            >
                              {{ Reverseassigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse pickup Assigned"
                            >
                              Reverse pickup Not Attempted:Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_pickup_Not_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse pickup Not Assigned"
                            >
                              {{ Reversenotassigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse pickup Not Assigned"
                            >
                              Reverse pickup Not Attempted:Rider Not Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_Picked_UP' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Picked UP"
                            >
                              {{ Reversepickup }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Picked UP"
                            >
                              Picked UP(HandoverPending)
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-green">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_NPR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR"
                            >
                              {{ Reversenpr }}
                            </h4>
                            <p
                              style="padding-bottom: 30px;padding-top: 10px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR"
                            >
                              NPR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_RTO' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center"
                              v-b-tooltip.hover
                              title="Return To Origin"
                            >
                              {{ Reverserto }}
                            </h4>
                            <p
                              style="padding-bottom: 30px;padding-top: 10px;"
                              class="text-center "
                              v-b-tooltip.hover
                              title=" Return To Origin"
                            >
                              RTO
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col
                    sm="6"
                    lg="2"
                    class="pointer"
                    v-if="userCountry == 'KSA'"
                  >
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: {
                              id: 'Reverse_pickup_Not_Assigned_Received',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center"
                              v-b-tooltip.hover
                              title="Reverse pickup Not Assigned Count"
                            >
                              {{ Reversepickupnotassigned }}
                            </h4>
                            <p
                              style="padding-bottom: 30px;padding-top: 10px;"
                              class="text-center "
                              v-b-tooltip.hover
                              title=" Reverse pickup Not Assigned"
                            >
                              Reverse Pickup
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- For ME End-->

                <!-- For KSA -->
                <b-row
                  class="boxto"
                  style="border-bottom: 2px dotted grey "
                  v-if="userCountry == 'KSA'"
                >
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_pickup_Not_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Shipment Created Count"
                            >
                              {{ Reversenotassigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Shipment Created"
                            >
                              RVP Created Shipment
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col
                    sm="6"
                    lg="2"
                    class="pointer"
                    v-if="userCountry == 'KSA'"
                  >
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: {
                              id: 'Reverse_pickup_Not_Assigned_Received',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center"
                              v-b-tooltip.hover
                              title="Received in HUB Count"
                            >
                              {{ Reversepickupnotassigned }}
                            </h4>
                            <p
                              class="text-center "
                              v-b-tooltip.hover
                              title="Received in HUB"
                            >
                              Received in HUB
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned Count"
                            >
                              {{ Reverseassigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned"
                            >
                              Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_Picked_UP' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="RVP pickup Up Count"
                            >
                              {{ Reversepickup }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="RVP pickup Up"
                            >
                              RVP pickup Up
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_RTO' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center"
                              v-b-tooltip.hover
                              title="Final RTO Count"
                            >
                              {{ Reverserto }}
                            </h4>
                            <p
                              class="text-center "
                              v-b-tooltip.hover
                              title="Final RTO"
                            >
                              Final RTO
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-green">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_NPR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR Count"
                            >
                              {{ Reversenpr }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR"
                            >
                              NPR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_ClientPickCancel' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="ClientPickCancel Count"
                            >
                              {{ ReverseClientPickCancel }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Client Pick Cancel"
                            >
                              Client Pick Cancel
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-red">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'Reverse_PickupPending' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="PickupPending Count"
                            >
                              {{ ReversePickupPending }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup Pending"
                            >
                              More Than 3 Days Pickup Pending
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- For KSA End-->
                <!-- Reverse & RTD End-->
              </div>

              <!-- Code For  Warrenty -->

              <div
                v-if="
                  pickuplocationmasterid == 365 ||
                    pickuplocationmasterid == 36058 ||
                    pickuplocationmasterid == 78731 || 
                    pickuplocationmasterid == 11
                "
              >
                <label style="padding-top: 10px!important"
                  >Reverse Warrenty:Customer To Warehouse</label
                >
                <!-- For Me -->
                <b-row class="boxto" v-if="userCountry == 'ME'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty pickup Assigned Count"
                            >
                              {{ Reverse_Warranty_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" Reverse Warrenty Pickup Assigned"
                            >
                              Not Attempted:Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty Pickup Not Assigned Count"
                            >
                              {{ Reverse_Warranty_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty Pickup Not Assigned"
                            >
                              Not Attempted:Rider Not Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Picked_UP' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Picked UP Count"
                            >
                              {{ Reverse_Warranty_Picked_UP }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Picked UP"
                            >
                              Picked UP
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <!-- <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-green">

                    
                </b-card>
              </b-col>  -->
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_RTO' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty RTO Count"
                            >
                              {{ Reverse_Warranty_RTO }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Return To Origin"
                            >
                              RTO
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-green">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Pick_Cancelled_NPR',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR Count"
                            >
                              {{ Reverse_Warranty_Pick_Cancelled_NPR }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR"
                            >
                              NPR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <!-- For ME End -->

                <!-- For KSA -->
                <b-row class="boxto" v-if="userCountry == 'KSA'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="RVP Created Shipment Count"
                            >
                              {{ Reverse_Warranty_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="RVP Created Shipment"
                            >
                              RVP Created Shipment
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Picked_UP' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Received in HUB Count"
                            >
                              {{ Reverse_Warranty_Picked_UP }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Received in HUB"
                            >
                              Received in HUB
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned Count"
                            >
                              {{ Reverse_Warranty_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" Rider Assigned"
                            >
                              Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <!-- <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">

                      
                  </b-card>
                </b-col>  -->
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_RTO' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NDR Received Count"
                            >
                              {{ Reverse_Warranty_RTO }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NDR Received"
                            >
                              NDR Received
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-green">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Pick_Cancelled_NPR',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR Count"
                            >
                              {{ Reverse_Warranty_Pick_Cancelled_NPR }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NPR"
                            >
                              NPR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <!-- For KSA End -->

                <label style="padding-top: 10px!important"
                  >Reverse Warrenty:Warehouse To Vendor</label
                >

                <!-- For ME  -->
                <b-row class="boxto" v-if="userCountry == 'ME'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_Pickup_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty Vendor pickup Assigned Count"
                            >
                              {{ Reverse_Warranty_Vendor_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" Reverse Warrenty Vendor pickup Assigned"
                            >
                              Not Attempted:Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty Vendor Pickup Not Assigned Count"
                            >
                              {{ Reverse_Warranty_Vendor_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warrenty Vendor Pickup Not Assigned"
                            >
                              Not Attempted:Rider Not Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id:
                                'Reverse_Warranty_Vendor_Delivered_BabyGear_Push',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor Delivered BabyGear Push Count"
                            >
                              {{
                                Reverse_Warranty_Vendor_Delivered_BabyGear_Push
                              }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor Delivered BabyGear Push"
                            >
                              Delivered
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_PickedUP_ROFD',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor PickedUP ROFD Count"
                            >
                              {{ Reverse_Warranty_Vendor_PickedUP_ROFD }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor PickedUP ROFD "
                            >
                              ROFD
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-red">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Vendor_RNDR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor RNDR Count"
                            >
                              {{ Reverse_Warranty_Vendor_RNDR }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Reverse Warranty Vendor RNDR "
                            >
                              RNDR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <!-- For ME End -->

                <!-- For KSA -->
                <b-row class="boxto" v-if="userCountry == 'KSA'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Shipment Created Count"
                            >
                              {{ Reverse_Warranty_Vendor_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Shipment Created"
                            >
                              RVP Created Shipment
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_Pickup_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned Count"
                            >
                              {{ Reverse_Warranty_Vendor_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned"
                            >
                              Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id:
                                'Reverse_Warranty_Vendor_Delivered_BabyGear_Push',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Today's Delivered at Customer Count"
                            >
                              {{
                                Reverse_Warranty_Vendor_Delivered_BabyGear_Push
                              }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Today's Delivered at Customer"
                            >
                              Today's Delivered at Customer
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Reverse_Warranty_Vendor_PickedUP_ROFD',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="ROFD Count"
                            >
                              {{ Reverse_Warranty_Vendor_PickedUP_ROFD }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="ROFD "
                            >
                              OFD
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-red">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Reverse_Warranty_Vendor_RNDR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="NDR Count"
                            >
                              {{ Reverse_Warranty_Vendor_RNDR }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="NDR"
                            >
                              NDR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- For KSA END -->

                <label style="padding-top: 10px!important"
                  >Forward Warrenty:Delivered To Customer</label
                >

                <!-- For ME -->

                <b-row class="boxto" v-if="userCountry == 'ME'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warrenty pickup Assigned Count"
                            >
                              {{ Forward_Warranty_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" Forward Warrenty pickup Assigned"
                            >
                              Not Attempted:Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Forward_Warranty_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty Pickup Not Assigned Count"
                            >
                              {{ Forward_Warranty_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty Pickup Not Assigned"
                            >
                              Not Attempted:Rider Not Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_INTransit' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty INTransit Count"
                            >
                              {{ Forward_Warranty_INTransit }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty INTransit"
                            >
                              INTransit
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Forward_Warranty_Delivered_at_Customer',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty Delivered at Customer Count"
                            >
                              {{ Forward_Warranty_Delivered_at_Customer }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty Delivered at Customer Count "
                            >
                              Delivered
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_PickedUP_OFD' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty PickedUP OFD Count"
                            >
                              {{ Forward_Warranty_PickedUP_OFD }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty PickedUP OFD"
                            >
                              OFD
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-red">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_NDR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty NDR Count"
                            >
                              {{ Forward_Warranty_NDR }}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty NDR"
                            >
                              NDR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- For ME End-->

                <!-- For KSA -->
                <b-row class="boxto" v-if="userCountry == 'KSA'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Forward_Warranty_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warranty Pickup Not Assigned Count"
                            >
                              {{ Forward_Warranty_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Shipment Created"
                            >
                              RVP Created Shipment
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned Count"
                            >
                              {{ Forward_Warranty_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Rider Assigned"
                            >
                              Rider Assigned
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_INTransit' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title=" INTransit Count"
                            >
                              {{ Forward_Warranty_INTransit }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" INTransit"
                            >
                              INTransit
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: {
                              id: 'Forward_Warranty_Delivered_at_Customer',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Today's Delivered at Customer Count "
                            >
                              {{ Forward_Warranty_Delivered_at_Customer }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Today's Delivered at Customer"
                            >
                              Today's Delivered at Customer
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_PickedUP_OFD' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title=" OFD Count"
                            >
                              {{ Forward_Warranty_PickedUP_OFD }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="OFD"
                            >
                              OFD
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-red">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'warrentyshipmentreport',
                            params: { id: 'Forward_Warranty_NDR' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title=" NDR Count"
                            >
                              {{ Forward_Warranty_NDR }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" NDR"
                            >
                              NDR
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- For KSA END -->

                <!-- Cross Country Dashboard -->

                <label
                  v-if="userCountry == 'ME' || userCountry == 'KSA'"
                  style="padding-top: 10px!important"
                  >Cross Country Shipments [WH to SkyEx]</label
                >
                <b-row
                  class="boxto"
                  v-if="userCountry == 'ME' || userCountry == 'KSA'"
                >
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: {
                              id: 'WH_CrossCountry_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Forward Warrenty pickup Assigned Count"
                            >
                              {{ WH_CrossCountry_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title=" Booking Pending"
                            >
                              Booking Pending
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: { id: 'WH_CrossCountry_Pickup_Assigned' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Booking Done"
                            >
                              {{ WH_CrossCountry_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Booking Done"
                            >
                              Booking Done
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: { id: 'WH_CrossCountry_Pickup_INTransit' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="INTransit"
                            >
                              {{ WH_CrossCountry_Pickup_INTransit }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="INTransit"
                            >
                              INTransit
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <label
                  v-if="userCountry == 'ME' || userCountry == 'KSA'"
                  style="padding-top: 10px!important"
                  >Cross Country Shipments [Vendor to WH]</label
                >
                <b-row
                  class="boxto"
                  v-if="userCountry == 'ME' || userCountry == 'KSA'"
                >
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: {
                              id: 'Vendor_CrossCountry_Pickup_Not_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup Not Assigned Count"
                            >
                              {{ Vendor_CrossCountry_Pickup_Not_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup Not Assigned"
                            >
                              Booking Pending
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: {
                              id: 'Vendor_CrossCountry_Pickup_Assigned',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup Assigned Count"
                            >
                              {{ Vendor_CrossCountry_Pickup_Assigned }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup Assigned"
                            >
                              Booking Done
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'crosscountryshipmentreport',
                            params: {
                              id: 'Vendor_CrossCountry_Pickup_INTransit',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup INTransit Count"
                            >
                              {{ Vendor_CrossCountry_Pickup_INTransit }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Vendor CrossCountry Pickup INTransit"
                            >
                              INTransit
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <!-- Cross Country Dashboard End-->
              </div>
              <div v-if="pickuplocationmasterid==365">
                <label v-if="userCountry == 'KSA'" style="padding-top: 10px!important">Hub To Hub</label>
                <b-row class="boxto" style="border-bottom: 2px dotted grey " v-if="userCountry == 'KSA'">
                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <router-link
                          tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: { id: 'WH_Pickup_Assigned_Hub_To_Hub' },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="HubToHub BookingDone Count"
                            >
                               {{ HubtoHubBookingDone }}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="HubToHub BookingDone"
                            >
                              HubToHub BookingDone
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>

                  <b-col  sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <router-link tag="li"
                          :to="{
                            name: 'shipmentreport',
                            params: {
                              id: 'WH_Pickup_Assigned_Hub_Intransit',
                            },
                          }"
                        >
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center"
                              v-b-tooltip.hover
                              title="HubToHub INTransit Count"
                            >
                              {{ hubtohubIntransit }}
                            </h4>
                            <p class="text-center " v-b-tooltip.hover title="HubToHub INTransit">
                              HubToHub INTransit
                            </p>
                          </b-card-body>
                        </router-link>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <div id="overlay" >
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

export default {
  name: "dashboard_adv",
  data: function() {
    return {
      name: "dashboard_adv",
      id: "",
      Firstmile: [],
      pickuplocationmasterid: "",
      Lasttmile: [],
      Reverse: [],
      a: -1,
      Firstmile3plpickupassigned: 0,
      Firstmile3plpickupnotassigned: 0,
      Firstmile3plpickupintransist: 0,
      Firstmile3plpickuppickcancel: 0,
      Firstmile3plpickuphandoverdone: 0,
      Firstmile3plpickupNotassignedreceived: 0,

      Firstmilep2ppickupassigned: 0,
      Firstmilep2ppickupnotassigned: 0,
      Firstmilep2ppickupintransist: 0,
      Firstmilep2ppickuppickcancel: 0,
      Firstmilep2ppickuphandoverdone: 0,
      Firstmilep2ppickupnotreceived: 0,

      FirstmileTrendyolpickupassigned: 0,
      FirstmileTrendyolpickupnotassigned: 0,
      FirstmileTrendyolpickupintransit: 0,
      FirstmileTrendyolpickuppickcancel: 0,
      FirstmileTrendyolpickuphandoverdone: 0,
      FirstmileTrendyolpickupNotassignedreceived: 0,

      LasttmileWH_Lasttmileclientpickcancle:0,
      LasttmileWH_Lasttmileexcessshipmentcount:0,
      LasttmileWH_Lasttmilemissingshipmentcount:0,
      LasttmileWH_Lasttmilepickupassigned: 0,
      LasttmileWH_Lasttmilepickupnotassigned: 0,
      LasttmileWH_Lasttmilepickupofd: 0,
      LasttmileWH_Lasttmilepickupcancel: 0,
      LasttmileWH_Lasttmiledeliveratcustomer: 0,
      LasttmileWH_Lasttmilepickndr: 0,
      LasttmileWH_Lasttmilerto: 0,
      LastmileWH_NDRReceived:0,
      LasttmileWHpickup: 0,
      LasttmileWH_Lasttmilereattemptcount: 0,
      LasttmileWH_HubInscan_Count: 0,
      LasttmileWH_RTOscan : 0,
      LastmileWH_RINTransit : 0,
      Lastsmile_WH_Pickup_OFP:0,
      LasttmileVendor_Lasttmilepickupassigned: 0,
      LasttmileVendor_Lasttmilepickupnotassigned: 0,
      LasttmileVendor_Lasttmilepickupofd: 0,
      LasttmileVendor_Lasttmilepickupnotcancel: 0,
      LasttmileVendor_Lasttmiledeliveratcustomer: 0,
      LasttmileVendor_Lasttmilepickcancelnpr: 0,
      LasttmileVendor_Lasttmilerto: 0,
      LasttmileVendor_NDRReceived:0,
      LastmileVendor_Vendor_Lastmile_RTO:0,
      LastmileVendor_Vendor_Lastmile_RINTransit:0,
      Lastmile_RTOINSCAN : 0,
      LasttmileVendor_Lasttmilereattemptcount: 0,
      LasttmileVendor_HubInscan_Count: 0,
      LasttmileVendor_Pickupnotassignedreceived: 0,

      //Lastmile Trendyol
      LasttmileTrendyol_Lasttmilepickupassigned: 0,
      LasttmileTrendyol_Lasttmilepickupnotassigned: 0,
      LasttmileTrendyol_Lasttmilepickupofd: 0,
      LasttmileTrendyol_Lasttmilepickupcancel: 0,
      LasttmileTrendyol_Lasttmiledeliveratcustomer: 0,
      LasttmileTrendyol_Lasttmilepickndr: 0,
      LasttmileTrendyol_Lasttmilerto: 0,



      Reverseassigned: 0,
      Reversepickup: 0,
      Reversenpr: 0,
      Reversepickupnotassigned:0,
      Reversenotassigned: 0,
      Reverserto: 0,
      ReverseClientPickCancel: 0,
      ReversePickupPending: 0,
      // Reversepickupnotassigned:0,

      //Code for Warrenty

      Reverse_Warranty: 0,
      Reverse_Warranty_Pickup_Assigned: 0,
      Reverse_Warranty_Pickup_Not_Assigned: 0,
      Reverse_Warranty_RTO: 0,
      Reverse_Warranty_Picked_UP: 0,
      Reverse_Warranty_Pick_Cancelled_NPR: 0,

      Reverse_Warranty_Vendor: 0,
      Reverse_Warranty_Vendor_Pickup_Not_Assigned: 0,
      Reverse_Warranty_Vendor_Delivered_BabyGear_Push: 0,
      Reverse_Warranty_Vendor_PickedUP_ROFD: 0,
      Reverse_Warranty_Vendor_Pickup_Assigned: 0,
      Reverse_Warranty_Vendor_RNDR: 0,

      Forward_Warranty: 0,
      Forward_Warranty_Pickup_Assigned: 0,
      Forward_Warranty_Pickup_Not_Assigned: 0,
      Forward_Warranty_PickedUP_OFD: 0,
      Forward_Warranty_Delivered_at_Customer: 0,
      Forward_Warranty_INTransit: 0,
      Forward_Warranty_NDR: 0,

      //Cross Country Dashboard
      WH_CrossCountry_Pickup_Assigned: 0,
      WH_CrossCountry_Pickup_INTransit: 0,
      WH_CrossCountry_Pickup_Not_Assigned: 0,

      Vendor_CrossCountry_Pickup_Assigned: 0,
      Vendor_CrossCountry_Pickup_INTransit: 0,
      Vendor_CrossCountry_Pickup_Not_Assigned: 0,
      //Code add by Sachin
      CountFirstmile3plpickupassigned: 0,
      CountFirstmile3plpickupnotassigned: 0,
      CountFirstmile3plpickupintransist: 0,
      CountFirstmile3plpickuppickcancel: 0,
      CountFirstmile3plpickuppickcancel: 0,
      CountFirstmile3plpickuphandoverdone: 0,
      CountFirstmile3plpickupNotassignedreceived: 0,

      CountLasttmileWH_Lasttmilepickupassigned: 0,
      CountLasttmileWH_Lasttmilepickupnotassigned: 0,
      CountLasttmileWH_Lasttmilepickupofd: 0,
      CountLasttmileWH_Lasttmilepickupcancel: 0,
      CountLasttmileWH_Lasttmiledeliveratcustomer: 0,
      CountLasttmileWH_Lasttmilepickndr: 0,
      CountLasttmileWH_Lasttmilerto: 0,
      CountLastmileWH_NDRReceived:0,
      CountLasttmileWH_Lasttmilereattemptcount: 0,
      CountLasttmile_Vendor_WH_HubInscan_Count: 0,
      CountLasttmile_Vendor_WH_Pickup_Count: 0,
      CountLasttmile_Vendor_WH_RTOSCAN_Count:0,
      CountLastmile_Vendor_WH_RINTransit_Count:0,

      hubtohubIntransit:0,
      HubtoHubBookingDone:0,
      RInScan : 0,

      scrolled: false,

      breadcrumbs: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
      b2bDashboardCount: {},
      b2bReverseDashboardCount: {},
      b2bDashboardColorArr: ['bg-aqua','bg-green','bg-yellow','bg-pink','bg-purpal','bg-cyan','bg-red','bg-def'],
      b2bRevDashboardColorArr: ['bg-dark','bg-cyan','bg-red','bg-def'],
      b2b_cms_url: null,
      showB2BDashboardLoader:false,
      failMsgForB2BDashboard:null,
    };
  },

  created: function() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.userCountry = userInfo.country;
    console.log("Country", this.userCountry);
    window.addEventListener("scroll", this.scroll);
    this.displayDashboardData();
    this.b2b_cms_url=`https://www.firstcrylogistics.com/b2b_cms/shipmentReport?status=`
  },

  destroyed() {
    // alert("innn");
    window.removeEventListener("scroll", this.scroll);
  },

  mounted() {
    this.lazyloadingcall();
    this.showB2BDashboardLoader = true
    setTimeout(()=>{
      if(this.userCountry=="KSA"){
          this.getb2bDashboardCountForAdmin();
      }
    },500)
  },

  methods: {
    getb2bDashboardCountForAdmin(){
      this.failMsgForB2BDashboard = null
      document.getElementById('overlay').style.display="none";
      var userdata = localStorage.getItem("userData");
      var userInfo = userdata ? JSON.parse(userdata) : null;
      const b2b_api_url = window.location.origin=='http://localhost:8080' ? `http://localhost:8086/b2b/getDashBoardAwbCount` : `${CONSTANTS.API_URL}/b2b/getDashBoardAwbCount`
      this.$http.post(b2b_api_url)
      .then((result)=>{
        this.showB2BDashboardLoader = false
        if (result.data.returnmsg === "Successful") {
          this.b2bDashboardCount=result.data.returnvalue.ParentAWB;
          this.b2bReverseDashboardCount = result.data.returnvalue.reverseParentAWB;
        }
        else {
          this.failMsgForB2BDashboard = "No Data Found!"
          console.log('failMsgForB2BDashboard',this.failMsgForB2BDashboard)

          this.b2bDashboardCount={};
          this.b2bReverseDashboardCount = {};
        }
      })
      .catch((error)=>{
        this.showB2BDashboardLoader = false
        this.failMsgForB2BDashboard = "Error in getting data!"
        console.log('failMsgForB2BDashboard',this.failMsgForB2BDashboard)
        this.$fire({
          text: "",
          type: "warning",
          timer: 30000
        }); 
      })

    },
    // onScroll : function () {
    //    console.log('aaa');
    //  },
    lazyloadingcall: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.pickuplocationmasterid = userInfo.pickuplocationmasterid;
      if (this.pickuplocationmasterid == 365) {
        // alert("i m in if")
        this.scroll();
      } else {
        const obj = {
          hub_id: `${userInfo.pickuplocationmasterid}`,
        };

        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforlastmile`,
            obj
          )
          .then((result) => {
            //alert("hiiiiiiiiiiiiiiiiii");
            if (result) {
              console.log("this.Lastsmile_WH_Pickup_OFP",this.Lastsmile_WH_Pickup_OFP)
              this.Lasttmile = result.body.returnvalue.Lasttmile;

              this.LasttmileWH_Lasttmileexcessshipmentcount = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Excess_Shipment_Count;

              this.LasttmileWH_Lasttmilemissingshipmentcount =  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Missing_Shipment_Count;

              console.log(" this.LasttmileWH_Lasttmilemissingshipmentcount", this.LasttmileWH_Lasttmilemissingshipmentcount)

              this.LasttmileWH_Lasttmileclientpickcancle =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.ClientPickCancel_Count;

              this.LasttmileWH_Lasttmilepickupassigned =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned;
              this.LasttmileWH_Lasttmilepickupnotassigned =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Not_Assigned;
              this.LasttmileWH_Lasttmilepickupofd =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_OFD;

              this.LasttmileWH_Lasttmilepickupcancel =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pick_Cancelled_NPR;

              this.LasttmileWH_Lasttmiledeliveratcustomer =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Delivered_at_Customer;
              this.LasttmileWH_Lasttmilepickndr =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_NDR;
              this.LasttmileWH_Lasttmilerto =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTO;
              this.LasttmileWHpickup =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Not_Assigned_Received;
              this.LasttmileWH_Lasttmilereattemptcount =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Reattempt_Count;
              this.LasttmileWH_HubInscan_Count =
                result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_HubInscan_Count;
              // console.log("Hiii",this.LasttmileWH_HubInscan_Count);
              this.LasttmileWH_RTOscan =result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTO;
              this.LastmileWH_RINTransit = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RINTransit ?
                                          result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RINTransit : this.LastmileWH_RINTransit;
              this.Lastsmile_WH_Pickup_OFP = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_OFP;
              this.LastmileWH_NDRReceived=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTOINSCAN;	
              this.LasttmileVendor_NDRReceived= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTOINSCAN;
              this.LastmileVendor_Vendor_Lastmile_RTO= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTO;
              this.LastmileVendor_Vendor_Lastmile_RINTransit= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RINTransit ?
                                                            result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RINTransit : this.LastmileVendor_Vendor_Lastmile_RINTransit;
              this.LasttmileVendor_Lasttmilepickupassigned =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Assigned;
              this.LasttmileVendor_Lasttmilepickupnotassigned =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned;
              this.LasttmileVendor_Lasttmilepickupofd =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_OFD;
              this.LasttmileVendor_Lasttmilepickupnotcancel =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pick_Cancelled_NPR;

              this.LasttmileVendor_Lasttmiledeliveratcustomer =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Delivered_at_Customer;
              this.LasttmileVendor_Lasttmilepickcancelnpr =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_NDR;
              this.LasttmileVendor_Lasttmilerto =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTO;
                this.Lastmile_RTOINSCAN =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTOINSCAN;
                
                
              this.LasttmileVendor_Lasttmilereattemptcount =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Reattempt_Count;
              this.LasttmileVendor_HubInscan_Count =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_HubInscan_Count;
              this.LasttmileVendor_Pickupnotassignedreceived =
                result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned_Received;

                this.HubtoHubBookingDone=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_To_Hub;
                this.hubtohubIntransit=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_Intransit;

              this.LasttmileTrendyol_Lasttmilepickupassigned =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Assigned ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Assigned : 0;
              this.LasttmileTrendyol_Lasttmilepickupnotassigned =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Not_Assigned ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Not_Assigned : 0;
              this.LasttmileTrendyol_Lasttmilepickupofd =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_OFD ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_OFD : 0;
              this.LasttmileTrendyol_Lasttmilepickupcancel =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pick_Cancelled_NPR ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pick_Cancelled_NPR : 0;
              this.LasttmileTrendyol_Lasttmiledeliveratcustomer =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Delivered_at_Customer ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Delivered_at_Customer : 0;
              this.LasttmileTrendyol_Lasttmilepickndr =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_NDR ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_NDR : 0;
              this.LasttmileTrendyol_Lasttmilerto =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_RTO ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_RTO : 0;
                

              // code for count

              this.CountLasttmileWH_Lasttmilepickupassigned =
                parseInt(this.LasttmileWH_Lasttmilepickupassigned) +
                parseInt(this.LasttmileVendor_Lasttmilepickupassigned) + 
                parseInt(this.LasttmileTrendyol_Lasttmilepickupassigned);

              this.CountLasttmileWH_Lasttmilepickupnotassigned =
                parseInt(this.LasttmileWH_Lasttmilepickupnotassigned) +
                parseInt(this.LasttmileVendor_Lasttmilepickupnotassigned) +
                parseInt(this.LasttmileTrendyol_Lasttmilepickupnotassigned);

              this.CountLasttmileWH_Lasttmilepickupofd =
                parseInt(this.LasttmileWH_Lasttmilepickupofd) +
                parseInt(this.LasttmileVendor_Lasttmilepickupofd) +
                parseInt(this.LasttmileTrendyol_Lasttmilepickupofd);

              this.CountLasttmileWH_Lasttmilepickupcancel =
                parseInt(this.LasttmileWH_Lasttmilepickupcancel) +
                parseInt(this.LasttmileVendor_Lasttmilepickupnotcancel) +
                parseInt(this.LasttmileTrendyol_Lasttmilepickupcancel);

              this.CountLasttmileWH_Lasttmiledeliveratcustomer =
                parseInt(this.LasttmileWH_Lasttmiledeliveratcustomer) +
                parseInt(this.LasttmileVendor_Lasttmiledeliveratcustomer) +
                parseInt(this.LasttmileTrendyol_Lasttmiledeliveratcustomer);

              this.CountLasttmileWH_Lasttmilepickndr =
                parseInt(this.LasttmileWH_Lasttmilepickndr) +
                parseInt(this.LasttmileVendor_Lasttmilepickcancelnpr) +
                parseInt(this.LasttmileTrendyol_Lasttmilepickndr);

              this.CountLasttmileWH_Lasttmilerto =
                parseInt(this.LasttmileWH_Lasttmilerto) +
                parseInt(this.LasttmileVendor_Lasttmilerto) +
                parseInt(this.LasttmileTrendyol_Lasttmilerto);

              this.CountLastmileWH_NDRReceived= parseInt(this.LastmileWH_NDRReceived) +
                parseInt(this.LasttmileVendor_NDRReceived);

              this.CountLasttmileWH_Lasttmilereattemptcount =
                parseInt(this.LasttmileWH_Lasttmilereattemptcount) +
                parseInt(this.LasttmileVendor_Lasttmilereattemptcount);
              this.CountLasttmile_Vendor_WH_HubInscan_Count =
                parseInt(this.LasttmileWH_HubInscan_Count) +
                parseInt(this.LasttmileVendor_HubInscan_Count);
                console.log("CountLasttmile_Vendor_WH_HubInscan_Count",this.CountLasttmile_Vendor_WH_HubInscan_Count)
              this.CountLasttmile_Vendor_WH_Pickup_Count =
                parseInt(this.LasttmileWHpickup) +
                parseInt(this.LasttmileVendor_Pickupnotassignedreceived);
              
                this.CountLasttmile_Vendor_WH_RTOSCAN_Count=
                parseInt(this.LasttmileWH_RTOscan) +
                parseInt(this.LastmileVendor_Vendor_Lastmile_RTO);

                this.CountLastmile_Vendor_WH_RINTransit_Count=
                parseInt(this.LastmileWH_RINTransit)+
                parseInt(this.LastmileVendor_Vendor_Lastmile_RINTransit);
            }
          });
        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreverse`,
            obj
          )
          .then((result) => {
            // alert("in");
            this.Reverse = result.body.returnvalue.Reverse;
            // console.log("Reverse",this.Reverse);

            this.Reverseassigned =
              result.body.returnvalue.Reverse.Reverse_Pickup_Assigned;

            this.Reversepickup =
              result.body.returnvalue.Reverse.Reverse_Picked_UP;
            this.Reversenpr = result.body.returnvalue.Reverse.Reverse_NPR;
            this.Reversenotassigned =
              result.body.returnvalue.Reverse.Reverse_pickup_Not_Assigned;
            this.Reverserto = result.body.returnvalue.Reverse.Reverse_RTO;
            this.Reversepickupnotassigned =
              result.body.returnvalue.Reverse.Reverse_pickup_Not_Assigned_Received;
            this.ReverseClientPickCancel = result.body.returnvalue.Reverse.Reverse_ClientPickCancel ? result.body.returnvalue.Reverse.Reverse_ClientPickCancel : 0;
            this.ReversePickupPending = result.body.returnvalue.Reverse.Reverse_PickupPending ? result.body.returnvalue.Reverse.Reverse_PickupPending : 0;
            // console.log("Hiii",this.Reversenotassigned);

            // alert("helllllllllllooooooooooo");
          });

        //Code For Reverse Count
        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreversewarranty`,
            obj
          )
          .then((result) => {
            // alert("in");
            // console.log("Result",result);
            this.Reverse_Warranty = result.body.returnvalue.Reverse_Warranty;
            this.Reverse_Warranty_Pickup_Assigned =
              result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pickup_Assigned;
            this.Reverse_Warranty_Pickup_Not_Assigned =
              result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pickup_Not_Assigned;
            this.Reverse_Warranty_RTO =
              result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_RTO;
            this.Reverse_Warranty_Picked_UP =
              result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Picked_UP;
            this.Reverse_Warranty_Pick_Cancelled_NPR =
              result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pick_Cancelled_NPR;
            // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
          });

        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreversewarrantytovendor`,
            obj
          )
          .then((result) => {
            // alert("in");
            // console.log("Result",result);
            this.Reverse_Warranty_Vendor =
              result.body.returnvalue.Reverse_Warranty_Vendor;
            this.Reverse_Warranty_Vendor_Pickup_Not_Assigned =
              result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Pickup_Not_Assigned;
            this.Reverse_Warranty_Vendor_Delivered_BabyGear_Push =
              result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Delivered_BabyGear_Push;
            this.Reverse_Warranty_Vendor_PickedUP_ROFD =
              result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_PickedUP_ROFD;
            this.Reverse_Warranty_Vendor_Pickup_Assigned =
              result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Pickup_Assigned;
            this.Reverse_Warranty_Vendor_RNDR =
              result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_RNDR;
            // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
          });

        this.$http
          .post(
            `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforforwardwarranty`,
            obj
          )
          .then((result) => {
            // alert("in");
            console.log("Result", result);
            this.Forward_Warranty = result.body.returnvalue.Forward_Warranty;
            this.Forward_Warranty_Pickup_Assigned =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_Pickup_Assigned;
            this.Forward_Warranty_Pickup_Not_Assigned =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_Pickup_Not_Assigned;
            this.Forward_Warranty_PickedUP_OFD =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_PickedUP_OFD;
            this.Forward_Warranty_Delivered_at_Customer =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_Delivered_at_Customer;
            this.Forward_Warranty_INTransit =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_INTransit;
            this.Forward_Warranty_NDR =
              result.body.returnvalue.Forward_Warranty.Forward_Warranty_NDR;
            // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
          });

        document.getElementById("element").style.display = "block";

        // this.scroll();
      }
    },

    displayDashboardData: function() {
      // var userdata = localStorage.getItem('userData')
      // var userInfo = JSON.parse(userdata)
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // console.log("UserInfo",userInfo);
      // alert(userInfo.pickuplocationmasterid);

      const obj = {
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };

      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforfirstmile`,
          obj
        )
        .then((result) => {
          //alert("hiiiiiiiiiiiiiiiiii");
          if (result) {
            this.Firstmile = result.body.returnvalue.Firstmile;

            this.Firstmile3plpickupassigned =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Pickup_Assigned;
            this.Firstmile3plpickupnotassigned =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Pickup_Not_Assigned;
            this.Firstmile3plpickupintransist =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Pickup_INTransit;
            this.Firstmile3plpickuppickcancel =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Pick_Cancelled;
            this.Firstmile3plpickuphandoverdone =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Hub_Handover_Done;
            this.Firstmile3plpickupNotassignedreceived =
              result.body.returnvalue.Firstmile.Firstmile_3PL_Hub_Drop.PL_Pickup_Not_Assigned_Received;
            console.log(
              "Firstmile3plpickupNotassignedreceived",
              this.Firstmile3plpickupNotassignedreceived
            );

            this.Firstmilep2ppickupassigned =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Pickup_Assigned;
            this.Firstmilep2ppickupnotassigned =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Pickup_Not_Assigned;
            this.Firstmilep2ppickupintransist =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Pickup_INTransit;
            this.Firstmilep2ppickuppickcancel =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Pick_Cancelled;
            this.Firstmilep2ppickuphandoverdone =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Handoverdone_to_P2P_Hub;
            this.Firstmilep2ppickupnotreceived =
              result.body.returnvalue.Firstmile.P2P_Hub_Drop.Vendor_Pickup_Not_Assigned_Received;

            this.FirstmileTrendyolpickupassigned = 
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Assigned ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Assigned : 0;
            this.FirstmileTrendyolpickupnotassigned =
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Not_Assigned ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Not_Assigned : 0;
            this.FirstmileTrendyolpickupintransit = 
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_INTransit ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_INTransit : 0;
            this.FirstmileTrendyolpickuppickcancel = 
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pick_Cancelled ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pick_Cancelled : 0;
            this.FirstmileTrendyolpickuphandoverdone = 
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Hub_Handover_Done ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Hub_Handover_Done : 0;
            this.FirstmileTrendyolpickupNotassignedreceived = 
              result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Not_Assigned_Received ? result.body.returnvalue.Firstmile.Firstmile_Trendyol.Trendyol_Pickup_Not_Assigned_Received : 0;

            this.Lasttmile = result.body.returnvalue.Lasttmile;

            // code for count
            this.CountFirstmile3plpickupassigned =
              parseInt(this.Firstmile3plpickupassigned) +
              parseInt(this.Firstmilep2ppickupassigned) +
              parseInt(this.FirstmileTrendyolpickupassigned);
            this.CountFirstmile3plpickupnotassigned =
              parseInt(this.Firstmile3plpickupnotassigned) +
              parseInt(this.Firstmilep2ppickupnotassigned) +
              parseInt(this.FirstmileTrendyolpickupnotassigned);
            this.CountFirstmile3plpickupintransist =
              parseInt(this.Firstmile3plpickupintransist) +
              parseInt(this.Firstmilep2ppickupintransist) +
              parseInt(this.FirstmileTrendyolpickupintransit);
            this.CountFirstmile3plpickuppickcancel =
              parseInt(this.Firstmile3plpickuppickcancel) +
              parseInt(this.Firstmilep2ppickuppickcancel) +
              parseInt(this.FirstmileTrendyolpickuppickcancel);
            this.CountFirstmile3plpickuphandoverdone =
              parseInt(this.Firstmile3plpickuphandoverdone) +
              parseInt(this.Firstmilep2ppickuphandoverdone) +
              parseInt(this.FirstmileTrendyolpickuphandoverdone);
            this.CountFirstmile3plpickupNotassignedreceived =
              parseInt(this.Firstmile3plpickupNotassignedreceived) +
              parseInt(this.Firstmilep2ppickupnotreceived) +
              parseInt(this.FirstmileTrendyolpickupNotassignedreceived);
          }
        });
    },

    scroll: function() {
      // alert("inn");
      // window.onscroll = () => {
      if ((this.scrolled = window.scrollY > 0)) {
        // console.log("ttttttt",window.scrollY);
        let ZoomCheck = Math.round(
          (window.outerWidth / window.innerWidth) * 100
        );
        console.log("ZoomCheck", ZoomCheck);
        let bottomOfWindow =
          ZoomCheck == 100
            ? document.documentElement.scrollTop + window.innerHeight ===
              document.documentElement.offsetHeight
            : ZoomCheck <= 67
            ? (document.documentElement.scrollTop + window.innerHeight ===
                document.documentElement.offsetHeight) +
              2
            : Math.round(
                document.documentElement.scrollTop + window.innerHeight
              ) +
                1 ===
              document.documentElement.offsetHeight;

        // console.log(
        //   "scrollTop",
        //   Math.round(document.documentElement.scrollTop + window.innerHeight) +
        //     1
        // );
        // console.log("offsetHeight", document.documentElement.offsetHeight);
        // console.log("window", bottomOfWindow);
        //  let scrollHeight = Math.max(
        //   document.body.scrollHeight, document.documentElement.scrollHeight,
        //   document.body.offsetHeight, document.documentElement.offsetHeight,
        //   document.body.clientHeight, document.documentElement.clientHeight
        // );
        //  console.log("scrollHeight",scrollHeight);

        if (bottomOfWindow) {
          // console.log("nnnnnnnnnn",this.scrolled);
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          // alert(userInfo.pickuplocationmasterid);

          const obj = {
            hub_id: `${userInfo.pickuplocationmasterid}`,
          };

          //alert(" i m in");
          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforlastmile`,
              obj
            )
            .then((result) => {
              //alert("hiiiiiiiiiiiiiiiiii");
              if (result) {
                this.Lasttmile = result.body.returnvalue.Lasttmile;
                this.LasttmileWH_Lasttmileexcessshipmentcount = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Excess_Shipment_Count;

              this.LasttmileWH_Lasttmilemissingshipmentcount =  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Missing_Shipment_Count;

              console.log(" this.LasttmileWH_Lasttmilemissingshipmentcount", this.LasttmileWH_Lasttmilemissingshipmentcount)

                this.LasttmileWH_Lasttmilepickupassigned =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned;
                this.LasttmileWH_Lasttmilepickupnotassigned =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Not_Assigned;
                this.LasttmileWH_Lasttmilepickupofd =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_OFD;
                this.LasttmileWH_Lasttmilepickupcancel =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pick_Cancelled_NPR;

                this.LasttmileWH_Lasttmiledeliveratcustomer =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Delivered_at_Customer;
                this.LasttmileWH_Lasttmilepickndr =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_NDR;
                this.LasttmileWH_Lasttmilerto =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTO;
                this.LastmileWH_NDRReceived=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTOINSCAN;
                this.Lastsmile_WH_Pickup_OFP = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_OFP;
                this.LasttmileWHpickup =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Not_Assigned_Received;
                console.log("HHHHHHHH", this.LasttmileWHpickup);
                this.LasttmileWH_Lasttmilereattemptcount =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Reattempt_Count;
                this.LasttmileWH_HubInscan_Count =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_HubInscan_Count;
                  this.LasttmileWH_RTOscan =
                  result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RTO;
                this.LastmileWH_RINTransit = result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RINTransit ?
                                              result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_RINTransit : this.LastmileWH_RINTransit;
               
                this.LasttmileVendor_Lasttmilepickupassigned =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Assigned;
                this.LasttmileVendor_Lasttmilepickupnotassigned =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned;
                this.LasttmileVendor_Lasttmilepickupofd =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_OFD;
                this.LasttmileVendor_Lasttmilepickupnotcancel =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pick_Cancelled_NPR;
                  this.LastmileVendor_Vendor_Lastmile_RTO= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTO;
                  this.LastmileVendor_Vendor_Lastmile_RINTransit= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RINTransit ? 
                                                                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RINTransit : this.LastmileVendor_Vendor_Lastmile_RINTransit;
                this.LasttmileVendor_Lasttmiledeliveratcustomer =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Delivered_at_Customer;
                this.LasttmileVendor_Lasttmilepickcancelnpr =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_NDR;
                this.LasttmileVendor_Lasttmilerto =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTO;
                  this.LasttmileVendor_NDRReceived= result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_RTOINSCAN;
                this.LasttmileVendor_Lasttmilereattemptcount =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Reattempt_Count;
                this.LasttmileVendor_HubInscan_Count =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_HubInscan_Count;
                this.LasttmileVendor_Pickupnotassignedreceived =
                  result.body.returnvalue.Lasttmile.Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned_Received;

                  this.HubtoHubBookingDone=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_To_Hub;
                this.hubtohubIntransit=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_Intransit;

                //           this.Reverse = result.body.returnvalue.Reverse;

                //   this.Reverseassigned=result.body.returnvalue.Reverse.Reverse_Pickup_Assigned;

                //    this.Reversepickup=result.body.returnvalue.Reverse.Reverse_Picked_UP;
                //   this.Reversenpr=result.body.returnvalue.Reverse.Reverse_NPR;
                // this.Reversenotassigned=result.body.returnvalue.Reverse.Reverse_pickup_Not_Assigned;
                //  this.Reverserto=result.body.returnvalue.Reverse.Reverse_RTO;

              this.LasttmileTrendyol_Lasttmilepickupassigned =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Assigned ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Assigned : 0;
              this.LasttmileTrendyol_Lasttmilepickupnotassigned =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Not_Assigned ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_Not_Assigned : 0;
              this.LasttmileTrendyol_Lasttmilepickupofd =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_OFD ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pickup_OFD : 0;
              this.LasttmileTrendyol_Lasttmilepickupcancel =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pick_Cancelled_NPR ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Pick_Cancelled_NPR : 0;
              this.LasttmileTrendyol_Lasttmiledeliveratcustomer =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Delivered_at_Customer ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_Delivered_at_Customer : 0;
              this.LasttmileTrendyol_Lasttmilepickndr =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_NDR ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_NDR : 0;
              this.LasttmileTrendyol_Lasttmilerto =
                result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_RTO ? result.body.returnvalue.Lasttmile.Trendyol_Lastmile.Trendyol_RTO : 0;
                // code for count

                this.CountLasttmileWH_Lasttmilepickupassigned =
                  parseInt(this.LasttmileWH_Lasttmilepickupassigned) +
                  parseInt(this.LasttmileVendor_Lasttmilepickupassigned) + 
                  parseInt(this.LasttmileTrendyol_Lasttmilepickupassigned);

                this.CountLasttmileWH_Lasttmilepickupnotassigned =
                  parseInt(this.LasttmileWH_Lasttmilepickupnotassigned) +
                  parseInt(this.LasttmileVendor_Lasttmilepickupnotassigned) +
                  parseInt(this.LasttmileTrendyol_Lasttmilepickupnotassigned);

                this.CountLasttmileWH_Lasttmilepickupofd =
                  parseInt(this.LasttmileWH_Lasttmilepickupofd) +
                  parseInt(this.LasttmileVendor_Lasttmilepickupofd) +
                  parseInt(this.LasttmileTrendyol_Lasttmilepickupofd);

                this.CountLasttmileWH_Lasttmilepickupcancel =
                  parseInt(this.LasttmileWH_Lasttmilepickupcancel) +
                  parseInt(this.LasttmileVendor_Lasttmilepickupnotcancel) +
                  parseInt(this.LasttmileTrendyol_Lasttmilepickupcancel);

                this.CountLasttmileWH_Lasttmiledeliveratcustomer =
                  parseInt(this.LasttmileWH_Lasttmiledeliveratcustomer) +
                  parseInt(this.LasttmileVendor_Lasttmiledeliveratcustomer) +
                  parseInt(this.LasttmileTrendyol_Lasttmiledeliveratcustomer);

                this.CountLasttmileWH_Lasttmilepickndr =
                  parseInt(this.LasttmileWH_Lasttmilepickndr) +
                  parseInt(this.LasttmileVendor_Lasttmilepickcancelnpr) +
                  parseInt(this.LasttmileTrendyol_Lasttmilepickndr);

                this.CountLasttmileWH_Lasttmilerto =
                  parseInt(this.LasttmileWH_Lasttmilerto) +
                  parseInt(this.LasttmileVendor_Lasttmilerto) +
                  parseInt(LasttmileTrendyol_Lasttmilerto);

                this.CountLasttmileWH_Lasttmilereattemptcount =
                  parseInt(this.LasttmileWH_Lasttmilereattemptcount) +
                  parseInt(this.LasttmileVendor_Lasttmilereattemptcount);
                  this.CountLasttmile_Vendor_WH_HubInscan_Count =
                parseInt(this.LasttmileWH_HubInscan_Count) +
                parseInt(this.LasttmileVendor_HubInscan_Count);
                // console.log("CountLasttmile_Vendor_WH_HubInscan_Count",this.CountLasttmile_Vendor_WH_HubInscan_Count)
                this.CountLasttmile_Vendor_WH_Pickup_Count =
                  parseInt(this.LasttmileWHpickup) +
                  parseInt(this.LasttmileVendor_Pickupnotassignedreceived);
                  this.CountLastmileWH_NDRReceived= parseInt(this.LastmileWH_NDRReceived) +
                parseInt(this.LasttmileVendor_NDRReceived);
                this.CountLasttmile_Vendor_WH_RTOSCAN_Count=
                parseInt(this.LasttmileWH_RTOscan) +
                parseInt(this.LastmileVendor_Vendor_Lastmile_RTO);

                this.CountLastmile_Vendor_WH_RINTransit_Count=
                parseInt(this.LastmileWH_RINTransit)+
                parseInt(this.LastmileVendor_Vendor_Lastmile_RINTransit);
              }
            });

          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreverse`,
              obj
            )
            .then((result) => {
              // alert("in");
              this.Reverse = result.body.returnvalue.Reverse;
              // console.log("Reverse",this.Reverse);

              this.Reverseassigned =
                result.body.returnvalue.Reverse.Reverse_Pickup_Assigned;

              this.Reversepickup =
                result.body.returnvalue.Reverse.Reverse_Picked_UP;
              this.Reversenpr = result.body.returnvalue.Reverse.Reverse_NPR;
              this.Reversenotassigned =
                result.body.returnvalue.Reverse.Reverse_pickup_Not_Assigned;
              this.Reverserto = result.body.returnvalue.Reverse.Reverse_RTO;
              this.Reversepickupnotassigned =
                result.body.returnvalue.Reverse.Reverse_pickup_Not_Assigned_Received;
              this.ReverseClientPickCancel = result.body.returnvalue.Reverse.Reverse_ClientPickCancel ? result.body.returnvalue.Reverse.Reverse_ClientPickCancel : 0;
              this.ReversePickupPending = result.body.returnvalue.Reverse.Reverse_PickupPending ? result.body.returnvalue.Reverse.Reverse_PickupPending : 0;
              // console.log("Hiii",this.Reversenotassigned);

              // alert("helllllllllllooooooooooo");
            });

          //Code For Reverse Count
          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreversewarranty`,
              obj
            )
            .then((result) => {
              // alert("in");
              // console.log("Result",result);
              this.Reverse_Warranty = result.body.returnvalue.Reverse_Warranty;
              this.Reverse_Warranty_Pickup_Assigned =
                result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pickup_Assigned;
              this.Reverse_Warranty_Pickup_Not_Assigned =
                result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pickup_Not_Assigned;
              this.Reverse_Warranty_RTO =
                result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_RTO;
              this.Reverse_Warranty_Picked_UP =
                result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Picked_UP;
              this.Reverse_Warranty_Pick_Cancelled_NPR =
                result.body.returnvalue.Reverse_Warranty.Reverse_Warranty_Pick_Cancelled_NPR;
              // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
            });

          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforreversewarrantytovendor`,
              obj
            )
            .then((result) => {
              // alert("in");
              // console.log("Result",result);
              this.Reverse_Warranty_Vendor =
                result.body.returnvalue.Reverse_Warranty_Vendor;
              this.Reverse_Warranty_Vendor_Pickup_Not_Assigned =
                result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Pickup_Not_Assigned;
              this.Reverse_Warranty_Vendor_Delivered_BabyGear_Push =
                result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Delivered_BabyGear_Push;
              this.Reverse_Warranty_Vendor_PickedUP_ROFD =
                result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_PickedUP_ROFD;
              this.Reverse_Warranty_Vendor_Pickup_Assigned =
                result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_Pickup_Assigned;
              this.Reverse_Warranty_Vendor_RNDR =
                result.body.returnvalue.Reverse_Warranty_Vendor.Reverse_Warranty_Vendor_RNDR;
              // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
            });

          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getdashboardshipmentcountforforwardwarranty`,
              obj
            )
            .then((result) => {
              // alert("in");
              console.log("Result", result);
              this.Forward_Warranty = result.body.returnvalue.Forward_Warranty;
              this.Forward_Warranty_Pickup_Assigned =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_Pickup_Assigned;
              this.Forward_Warranty_Pickup_Not_Assigned =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_Pickup_Not_Assigned;
              this.Forward_Warranty_PickedUP_OFD =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_PickedUP_OFD;
              this.Forward_Warranty_Delivered_at_Customer =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_Delivered_at_Customer;
              this.Forward_Warranty_INTransit =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_INTransit;
              this.Forward_Warranty_NDR =
                result.body.returnvalue.Forward_Warranty.Forward_Warranty_NDR;
              // console.log("Jjjjj",this.Reverse_Warranty_Picked_UP);
            });

          this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getDashboardCrossCountryShipmentCount`,
              obj
            )
            .then((result) => {
              // For WH
              this.WH_CrossCountry_Pickup_Assigned =
                result.body.returnvalue.CrossCountryFirstmile.WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_Assigned;
              this.WH_CrossCountry_Pickup_INTransit =
                result.body.returnvalue.CrossCountryFirstmile.WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_INTransit;
              this.WH_CrossCountry_Pickup_Not_Assigned =
                result.body.returnvalue.CrossCountryFirstmile.WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_Not_Assigned;

              // For Vendor
              this.Vendor_CrossCountry_Pickup_Assigned =
                result.body.returnvalue.CrossCountryFirstmile.Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_Assigned;
              this.Vendor_CrossCountry_Pickup_INTransit =
                result.body.returnvalue.CrossCountryFirstmile.Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_INTransit;
              this.Vendor_CrossCountry_Pickup_Not_Assigned =
                result.body.returnvalue.CrossCountryFirstmile.Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_Not_Assigned;
            });

          this.$http
            .post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardShipmentCountForRInScan`, 
            obj)
            .then((result) => {
              this.RInScan = result.body.returnvalue.RInScan.RInScan
              console.log(this.RInScan)
            });

          document.getElementById("element").style.display = "block";
        }
      }
    },

    goToB2B: function(event){
      const hrefValue = event.currentTarget.getAttribute('href')
      if(window.location.origin=='http://localhost:8080'){
       
        const data = {}
        data.userData = localStorage.getItem('userData');
        data.country = localStorage.getItem('country');
        const win = window.open(`${"http://localhost:8081/b2b_cms/shipmentReport?status="+hrefValue}&isFromLocalhost=true`, '_blank');

        window.addEventListener('message', function handshakeListener(event) {
          if (event.origin !== 'http://localhost:8081') {
            console.log('event origin wrong!!!!')
            return;
          }
          if (event.data === 'ready') {
            console.log('event data ready---->')
            win.postMessage(data, 'http://localhost:8081');
            window.removeEventListener('message', handshakeListener);
          }
        });

      }else{
        window.open(`${this.b2b_cms_url+hrefValue}`,'_blank')
      }
    },
  },
};
</script>

<style>
.dashboard-container li{
  height: 105px !important;
}

.dashboard-container .display-3 {
  font-size: 3rem !important;
}

.bg-aqua {
  background-color: #00c0ef !important;
  color: #fff !important;
}
.bg-green {
  background-color: #00a65a !important;
  color: #fff !important;
}
.bg-yellow {
  background-color: #f39c12 !important;
  color: #fff !important;
}
.bg-pink {
  background-color: #ff69b4 !important;
  color: #fff !important;
}
.bg-purpal {
  background-color: #9370db !important;
  color: #fff !important;
}
.bg-cyan {
  background-color: #008b8b !important;
  color: #fff !important;
}
.bg-red {
  background-color: #dd4b39 !important;
  color: #fff !important;
}
.bg-def {
  background-color: #f09642 !important;
  color: #fff !important;
}
.boxto .card-body {
  padding: 0px !important;
}
.heading {
  padding: 12px 12px 5px 12px !important;
}
.countcolor {
  color: white !important;
}
.pointer {
  cursor: pointer !important;
}
</style>
